import { useState, useEffect } from "react"
import Sidebar from "../components/Sidebar";
import Notification from "../components/Notification";
import Header from "../components/Header";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faServer } from '@fortawesome/free-solid-svg-icons'
import { faEye, faEyeSlash, faCreditCard } from '@fortawesome/free-regular-svg-icons'
import SubscribeCard from "../components/SubscribeCard";
import { Link } from "react-router-dom"
import { formatCurrency, getCurrencySymbol } from '../utils/currencyUtils';
import { useUser } from "../utils/UserContext";


function Subscribe() {
  const { user } = useUser();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [notificationbar, setNotificationbar] = useState(false);
  const toggleNotification = () => {
    setNotificationbar(!notificationbar);
  };
  const [settingsBar, setSettingsBar] = useState(false);
  const toggleSettingsBar = () => {
    setSettingsBar(!settingsBar);
  };
  const [see, setSee] = useState(true);
  const usdbal = user?.balance;
  const [plans, setPlans] = useState([]);
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}controller/fetch.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ fetchPlan: true })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        setPlans(data.plans);
      }
    })
    .catch(err => {
      console.log(err);
        console.error('Error fetching signals!')
    })
  }, [user]);
  return (
    <div className="container-fluid">
      <div className="row g-0">
        <Notification isOpen={notificationbar} toggleNotification={toggleNotification}/>
        <Sidebar title="Subscribe" isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} toggleSettingsBar={toggleSettingsBar} settingsBar={settingsBar}/>
        <div className="col ps-md-2 mainBar">
          <Header title="Subscribe" icon={<FontAwesomeIcon icon={faServer} style={{fontSize: '16px'}} />} toggleSidebar={toggleSidebar} toggleNotification={toggleNotification} toggleSettingsBar={toggleSettingsBar}/>
          <main>
            <div className="row">
              <div className="col-12">
                <div className="mycard mt-2">
                  <div className="d-md-flex justify-content-between mb-4">
                    <div>
                        <div className="d-flex justify-content-between align-items-center">
                            <p className="text-secondary fw-bold mb-0">Total Balance: <FontAwesomeIcon icon={(see === true)?faEye:faEyeSlash} className="ms-2" style={{fontSize: '16px'}} onClick={() => {
                            setSee(see === true ? false : true);
                            }}/></p>
                        </div>
                        <h2 className="fs-4 fw-bold">{see ? `${getCurrencySymbol(user?.currency)}${formatCurrency(usdbal)}` : '******'}</h2>
                    </div>
                    <Link to="/deposit" className="noLink">
                        <div className="myBtn text-white" style={{fontSize: '15px', padding: '8px 12px', backgroundColor: 'rgba(255, 255, 255, 0.05)'}}><FontAwesomeIcon icon={faCreditCard} style={{fontSize: '14px'}} className="me-1"/> Deposit</div>
                    </Link>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="text-secondary fw-bold mb-0">{user?.subscription}</p>
                    <p className="text-prime mb-0 fw-bold" style={{cursor: 'pointer'}}>{getCurrencySymbol(user?.currency)}{formatCurrency(user?.subscription_amount)}</p>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <h5 className="mb-4 fw-bold text-white mt-5 ms-2">Plans</h5>
                <div className="row">
                  {plans.map((plan) => (
                    <div className="col-lg-4 col-6 col-12" key={plan.id}>
                      <SubscribeCard key={plan.id} name={plan.subscribe_name} price={plan.amount} duration={plan.duration} roi={plan.percentage} features={plan.features}/>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  )
}

export default Subscribe